import { defineStore } from 'pinia'
import type { DeviceDefinition } from '~/repository/types/device'
import type { DeviceDefinition as CMSDeviceDefinition } from '~/repository/types/directus/device/deviceDefinition'
import { type IApiInstance } from '../plugins/api'
import type { DeviceAssignment } from '~/repository/types/device-assignment'

export type IDevicesState = {
  isLoaded: boolean
  devices: CMSDeviceDefinition[]
  deviceDefinitions: DeviceDefinition[]
  assignments: DeviceAssignment[]
}

export const useDevicesStore = defineStore('devices', {
  state: (): IDevicesState => {
    return {
      isLoaded: false,
      devices: [],
      deviceDefinitions: [],
      assignments: [],
    }
  },
  getters: {
    getDeviceById: (state) => (id: string) => {
      return state.devices.find((t: any) => t.id === id)
    },
    getDeviceDefinitionById: (state) => (id: string) => {
      return state.deviceDefinitions.find((t: any) => t.id === id)
    },
    getDevicesWithSim: (state) => () => {
      return state.devices.filter((t: any) => t.sim === true)
    },
  },
  actions: {
    async load() {
      const api: IApiInstance = useNuxtApp().$api as IApiInstance

      const devices = (
        await api.cms.get(
          'devices',
          `fields[]=Manufacturer,id&fields[]=translations.name,translations.short_name,translations.display_name, protected_assignation,sim`,
        )
      ).data

      const deviceDefinitions = await api.devices.getDefinitions()

      if (this.devices && deviceDefinitions) {
        this.$patch({ isLoaded: true, devices, deviceDefinitions })
      }

      //this.commit('practitioners/setPractitioners', practitioners)
    },
    async loadDeviceAssignment() {
      const api: IApiInstance = useNuxtApp().$api as IApiInstance
      const assignments = await api.deviceAssignments.getAssignedByMe()
      this.assignments = assignments
    },
    setDeviceAssignment(_assignments: DeviceAssignment[]) {
      try {
        this.$patch({
          assignments: _assignments,
        })
      } catch (error) {
        this.$patch({ isLoaded: false })
        console.log(error)
      }
    },
    /**
     * An action to clear the user data from the storage, should be used upon signing out the user.
     *
     * @param {object} context - VueX store context containing commit helper for mutations.
     */
    clear() {
      this.$reset()
    },
  },
})
